import React from "react";
import differenceInSeconds from "date-fns/difference_in_seconds";

//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { useExpertMessageContext } from "./expert-message/ExpertMessageContext";
import { isStateLocked } from "@limitless/portal";
export const useMessageClaimExtension = () => {
  const log = pilog.getLogger("useMessageClaimExtension");
  const [activityIdleTimeout, setActivityIdleTimeout] = React.useState(0);
  const {
    message,
    claimTimeoutIncrement
  } = useExpertMessageContext();
  const {
    conversationState: {
      state
    }
  } = message;
  let inbox = {
    ...message.inbox
  };
  if (!inbox) {
    inbox = {};
  }
  const {
    claimed,
    claimedAt,
    claimTimeout,
    claimTimeoutInc
  } = inbox;
  let interval;
  log.debug(message);
  React.useEffect(() => {
    return () => {
      clearInterval(interval);
      setActivityIdleTimeout(0);
    };
  }, []);
  React.useEffect(() => {
    if (isStateLocked(state)) {
      clearInterval(interval);
      setActivityIdleTimeout(0);
    }
  }, [state]);
  React.useEffect(() => {
    if (claimed) {
      setActivityIdleTimeout(0);
      const lapsedClaimTime = differenceInSeconds(new Date(), claimedAt);
      const isClaimExtended = lapsedClaimTime > Math.round(claimTimeout / 100 * 80);
      initialiseActivityTimer(claimTimeout + (isClaimExtended ? claimTimeoutInc : 0));
    }
  }, [claimed]);
  const initialiseActivityTimer = claimTimeInSec => {
    const actualClaimTimeoutInSec = claimTimeInSec - differenceInSeconds(new Date(), claimedAt);
    const checkActivityPause = Math.round(actualClaimTimeoutInSec / 100 * 80 * 1000);
    const checkActivityAwake = Math.round(actualClaimTimeoutInSec / 100 * 20 * 1000);
    interval = setInterval(() => {
      if (claimed) {
        clearInterval(interval);
        setActivityIdleTimeout(checkActivityAwake);
      }
    }, checkActivityPause);
  };

  // called when a change in idolness is detected by the expert
  const handleClaimTimeOutIncrement = ({
    idle
  }) => {
    setActivityIdleTimeout(0);
    if (!idle) {
      claimTimeoutIncrement(({
        totalIncrement
      }) => initialiseActivityTimer(totalIncrement + claimTimeout));
    }
  };

  // Make the context object:
  return {
    activityIdleTimeout,
    onTimeoutIncrement: handleClaimTimeOutIncrement
  };
};